import { render, staticRenderFns } from "./AddQuotes.vue?vue&type=template&id=6ea60235"
import script from "./AddQuotes.vue?vue&type=script&lang=js"
export * from "./AddQuotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports